module.exports = __webpack_public_path__ + "static/media/building-location.0bf61e81.svg";